import React from "react";
import "./PillButton.css";

/**
 * PillButton
 * Reusable pill-shaped link button component.
 * Props:
 * - href: string (required)
 * - label: string (required)
 * - external: boolean (optional) adds target/rel
 * - icon: ReactNode (optional) displayed before label
 * - className: string (optional) extra classes
 */
export default function PillButton({ href, label, external = false, icon, className = "" }) {
  return (
    <a
      href={href}
      className={`PillButton ${className}`}
      target={external ? "_blank" : undefined}
      rel={external ? "noreferrer" : undefined}
      aria-label={label}
      title={label}
    >
      {icon}
      <span className="PillButton__label">{label}</span>
    </a>
  );
}
